import React from 'react'
import PropTypes from 'prop-types'
import { FilterGroup } from 'components/common/Filters/FilterGroup'
import Media from 'components/common/Media'

const BOTRefinementMenu = ({ applyFilter, displayName, ...props }) =>
  <Media.Desktop>
    <FilterGroup
      { ...props }
      title={ displayName }
      onChange={ applyFilter } />
  </Media.Desktop>

export default BOTRefinementMenu

BOTRefinementMenu.propTypes = {
  applyFilter: PropTypes.func,
  displayName: PropTypes.string
}
